import { confirm } from './imperative'

type BlockAlertOptions = {
  main: string
  confirmLabel: string
  path?: string
  resource?: { humanName: { singular: string } }
  blockRedo: boolean
  finishedKind: boolean
  onNavigate?: (path: string) => void
}

export async function showBlockAlertDialog(
  options: BlockAlertOptions
): Promise<void> {
  const { main, confirmLabel, path, resource, blockRedo, finishedKind, onNavigate } =
    options

  let title = 'Recurso bloqueado'
  let description = main

  if (blockRedo) {
    title = 'Recurso já completado'
    description = `${main}\n\nAcesse outros recursos na plataforma para continuar recebendo recompensas.`
  } else if (resource) {
    description = `${main}\n\nVocê pode acessar a/o ${resource.humanName.singular.toLowerCase()} e concluir as etapas necessárias para desbloquear.`
  }

  const confirmed = await confirm({
    title,
    description,
    variant: 'info',
    confirmLabel,
    cancelLabel: finishedKind ? 'Não, ver depois' : undefined,
    showCancel: finishedKind,
    confirmVariant: 'default'
  })

  if (finishedKind && confirmed && path && onNavigate) {
    onNavigate(path)
  }
}
